export function get(object, path) {
    const keys = path.split('.');
    let result = object;
    keys.forEach((key) => {
        result = result[key] ?? '';
    });
    return result;
}
export * from './validate';
export * from './deep-assign';
export * from './platform';
export * from './promisify';
